import { Link } from "react-router-dom";
import { Coffee } from "lucide-react";

export default function TipCancel() {
  return (
    <div className="min-h-[60vh] grid place-items-center px-4 py-12" data-testid="tip-cancel-page">
      <div className="max-w-md text-center">
        <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-slate-100 dark:bg-slate-800 grid place-items-center">
          <Coffee className="w-6 h-6 text-slate-500 dark:text-slate-400" />
        </div>
        <h1 className="font-heading text-2xl font-semibold text-slate-900 dark:text-slate-100">No worries — nothing was charged.</h1>
        <p className="text-slate-600 dark:text-slate-300 mt-2 leading-relaxed">
          You cancelled the checkout before completing the tip. If you change your mind you can head back
          any time — the button is still on the site.
        </p>
        <Link to="/" className="inline-block mt-6 text-sm text-sky-700 dark:text-sky-300 hover:underline">← Back to the site</Link>
      </div>
    </div>
  );
}
